import { FontSizes, Separator } from "@fluentui/react"
import { Checkbox, Label, Text, Input, Field, Spinner, MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components"

// I18Next
import { useTranslation } from 'react-i18next';

// style
import '../ContractStageMultiSelector.Style.css';

// component functions
import * as ComponentFuntions from './ContractStageMultiselectorItem.Functions';
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { ContractConceptPaymentSchedule } from "../../../../../models/Entities/Contracts/ContractConceptPaymentSchedule";
import { NewContractConceptPaymentSchedule } from "../../../../../models/Entities/Contracts/NewContractConceptPaymentSchedule";
import { processSilentRenew } from "redux-oidc";

const ContractStageMultiselectorItemComponent = (props: ComponentFuntions.Props) => {

  // useTranslation
  const [t] = useTranslation();

  // properties
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [amount, setAmount] = useState<number>(1);
  const [SettlementCoeficient, setSetlementCoeficient] = useState<number>(1);
  const [inPersonPrice, setInPersonPrice] = useState<number>(0);
  const [remotePrice, setRemotePrice] = useState<number>(0);
  const [phonePrice, setPhonePrice] = useState<number>(0);
  const [followUpPrice, setFollowUpPrice] = useState<number>(0);
  const [failurePrice, setFailurePrice] = useState<number>(0);
  const [settlementRemoteCoefficient, setSettlementRemoteCoefficient] = useState<number>(1);
  const [settlementPhoneCoefficient, setSettlementPhoneCoefficient] = useState<number>(1);
  const [settlementFollowUpCoefficient, setSettlementFollowUpCoefficient] = useState<number>(1);
  const [settlementScreeningFailureCoefficient, setSettlementScreeningFailureCoefficient] = useState<number>(1);

  const [isChanged, setIsChanged] = useState<boolean>(false);
  const [pendingOperation, setPendingOperation] = useState<'add' | 'update' | 'delete' | null>(null);

  // useEffect(() => {
  //     setIsChanged(true);
  // }, [isSelected, amount, SettlementCoeficient, inPersonPrice, remotePrice, failurePrice])

  useEffect(() => {
    if (props.CurrentConceptPaymentSchedule) {
      setIsSelected(props.CurrentConceptPaymentSchedule ? true : false);
      setAmount(props.CurrentConceptPaymentSchedule?.amountExpected || 1);
      setSetlementCoeficient(props.CurrentConceptPaymentSchedule?.settlementCoefficient);
      setInPersonPrice(props.CurrentConceptPaymentSchedule?.price);
      setRemotePrice(props.CurrentConceptPaymentSchedule?.remotePrice);
      setPhonePrice(props.CurrentConceptPaymentSchedule?.phonePrice || 0);
      setFollowUpPrice(props.CurrentConceptPaymentSchedule?.followUpPrice || 0);
      setFailurePrice(props.CurrentConceptPaymentSchedule?.screeningFailurePrice);
      setSettlementRemoteCoefficient(props.CurrentConceptPaymentSchedule?.settlementRemoteCoefficient || 1);
      setSettlementPhoneCoefficient(props.CurrentConceptPaymentSchedule?.settlementPhoneCoefficient || 1);
      setSettlementFollowUpCoefficient(props.CurrentConceptPaymentSchedule?.settlementFollowUpCoefficient || 1);
      setSettlementScreeningFailureCoefficient(props.CurrentConceptPaymentSchedule?.settlementScreeningFailureCoefficient || 1);
    }
  }, [props.CurrentConceptPaymentSchedule !== undefined])

  useEffect(() => {
    if (props.bulkSelectionValue === undefined) {
      return;
    }

    setIsSelected(props.bulkSelectionValue);
    setIsChanged(true);
  }, [props.bulkSelectionVersion]);

  useEffect(() => {
    if (props.ContractConceptId && props.ConceptSaved) {
      if (props.ConceptSaved && isChanged) {
        const auxPaymentSchedule = {
          id: props.CurrentConceptPaymentSchedule?.id || undefined,
          contractConceptId: props.ContractConceptId || 0,
          contractStageId: props.StageId,
          amountExpected: amount || 0,
          settlementCoefficient: SettlementCoeficient || 0,
          price: inPersonPrice || 0,
          remotePrice: remotePrice || 0,
          phonePrice: phonePrice || 0,
          screeningFailurePrice: failurePrice || 0,
          settlementRemoteCoefficient: settlementRemoteCoefficient || 0,
          settlementPhoneCoefficient: settlementPhoneCoefficient || 0,
          settlementFollowUpCoefficient: settlementFollowUpCoefficient || 0,
          settlementScreeningFailureCoefficient: settlementScreeningFailureCoefficient || 0,
          priceWithoutOverhead: inPersonPrice || 0,
          followUpPrice: followUpPrice || 0,
          currency: props.CurrencyCode
        };
        if (isSelected) {
          //alert('Saving payment schedule for StageId: ' + props.StageId);
          if (props.CurrentConceptPaymentSchedule) {
            setPendingOperation('update');
            props.UpdateContractConceptPaymentSchedule(
              props.ContractId,
              props.ContractAddendumId,
              auxPaymentSchedule as ContractConceptPaymentSchedule
            );
          } else {
            setPendingOperation('add');
            props.AddContractConceptPaymenSchedule(
              props.ContractId,
              props.ContractAddendumId,
              auxPaymentSchedule as NewContractConceptPaymentSchedule
            );
          }
        } else {
          if (props.CurrentConceptPaymentSchedule) {
            setPendingOperation('delete');
            props.DeleteContractConceptPaymentSchedule(
              props.CurrentConceptPaymentSchedule.id,
              props.CurrentConceptPaymentSchedule.contractConceptId,
              props.ContractAddendumId,
              props.ContractId
            );
          } else {
            // no seleccionado y sin schedule previo: nada que hacer
            props.isSavedItem(props.StageId);
          }
        }
      } else {
        props.isSavedItem(props.StageId);
      }
    } 
  }, [props.ConceptSaved, props.ContractConceptId]);

  useEffect(() => {
    if (!pendingOperation) {
      return;
    }

    const failed =
      props.FailOnSaving === true ||
      props.FailOnUpdating === true ||
      props.FailOnDeleting === true;

    const addDone = pendingOperation === 'add' && !!props.CurrentConceptPaymentSchedule;
    const updateDone = pendingOperation === 'update' && props.CurrentConceptPaymentSchedule?.isUpdatedSuccessfully === true;
    const deleteDone = pendingOperation === 'delete' && !props.CurrentConceptPaymentSchedule;

    if (failed || addDone || updateDone || deleteDone) {
      setPendingOperation(null);
      props.isSavedItem(props.StageId);
    }
  }, [
    pendingOperation,
    props.CurrentConceptPaymentSchedule,
    props.FailOnSaving,
    props.FailOnUpdating,
    props.FailOnDeleting,
    props.StageId
  ]);

  return (
    <div className={isSelected ? 'StageSelectorContainer Selected' : 'StageSelectorContainer'}>
      <div className='StageSelectorColumn StageSelectorColumnStage'>
        <div>
          <Checkbox
            label={props.Stage.stageName}
            checked={isSelected}
            onChange={(ev, checked) => {
              setIsSelected(checked.checked as boolean);
              setIsChanged(true);
            }}
          />
          {pendingOperation !== null && <Spinner size="extra-tiny" />}
        </div>
        <div className='stageBadge'>
          <Text className='badge mini blue'>{props.Stage.isOnSiteMandatory ? t('protocolStageMultiSelector.stagesSelected.inPersonVisit') : t('protocolStageMultiSelector.stagesSelected.remoteVisit')}</Text>
        </div>
        <div>
          {props.errorOnSaving && <MessageBar key={'error'} intent={'error'} aria-multiline='true' >
            <MessageBarBody>
              <MessageBarTitle>Error</MessageBarTitle>
              {props.errorOnSaving?.ErrorMessage}
            </MessageBarBody>
          </MessageBar>}
        </div>
      </div>
      <div className='StageSelectorColumn StageSelectorColumnQuantity'>
        {isSelected && (
          <>
            <div className='StageSelectorColumnHeader'>Cantidad</div>
            <Field label={'Cantidad'}>
              <Input
                id="amount"
                type="number"
                style={{ maxWidth: '6em' }}
                step={1}
                defaultValue={amount?.toString()}
                onChange={
                  (ev, value) => {
                    setAmount(parseInt(value.value));
                    setIsChanged(true);
                  }
                }
                onFocus={e => e.target.select()}
              />
            </Field>
          </>
        )}
      </div>
      <div className='StageSelectorColumn StageSelectorColumnCoefficients'>
        {isSelected && (
          <>
            <div className='StageSelectorColumnHeader'>Coeficientes</div>
            {props.applyToInFaceExecution && <Field label={'Coef. Liq.'}>
              <Input
                id="settlementCoefficient"
                type="number"
                style={{ maxWidth: '10em' }}
                step={0.01}
                defaultValue={SettlementCoeficient?.toString()}
                onChange={
                  (ev, value) => {
                    setSetlementCoeficient(Number.parseFloat(value.value));
                    setIsChanged(true);
                  }}
                onFocus={e => e.target.select()}
              />
            </Field>}
            {props.applyToRemoteExecution && <Field label={'Coef. liquidación remoto'}>
              <Input
                id="settlementRemoteCoefficient"
                type="number"
                style={{ maxWidth: '10em' }}
                step={0.01}
                defaultValue={(props.CurrentConceptPaymentSchedule?.settlementRemoteCoefficient || 1).toString()}
                onFocus={e => e.target.select()}
                onChange={(ev, value) => {
                  setSettlementRemoteCoefficient(Number.parseFloat(value.value));
                  setIsChanged(true);
                }}
              />
            </Field>}
            {props.applyToPhoneExecution && <Field label={'Coef. liquidación telefónico'}>
              <Input
                id="settlementPhoneCoefficient"
                type="number"
                style={{ maxWidth: '10em' }}
                step={0.01}
                defaultValue={(props.CurrentConceptPaymentSchedule?.settlementPhoneCoefficient || 1).toString()}
                onFocus={e => e.target.select()}
                onChange={(ev, value) => {
                  setSettlementPhoneCoefficient(Number.parseFloat(value.value));
                  setIsChanged(true);
                }}
              />
            </Field>}
            {props.applyToFollowUpExecution && <Field label={'Coef. liquidación seguimiento'}>
              <Input
                id="settlementFollowUpCoefficient"
                type="number"
                style={{ maxWidth: '10em' }}
                step={0.01}
                defaultValue={(props.CurrentConceptPaymentSchedule?.settlementFollowUpCoefficient || 1).toString()}
                onFocus={e => e.target.select()}
                onChange={(ev, value) => {
                  setSettlementFollowUpCoefficient(Number.parseFloat(value.value));
                  setIsChanged(true);
                }}
              />
            </Field>}
            {props.applyToFailvisitExecution && props.Stage.failSelectionEnabled && (
              <Field label={'Coef. liquidación falla de selección'}>
                <Input
                  id="settlementScreeningFailureCoefficient"
                  type="number"
                  style={{ maxWidth: '10em' }}
                  step={0.01}
                  defaultValue={(props.CurrentConceptPaymentSchedule?.settlementScreeningFailureCoefficient || 1).toString()}
                  onFocus={e => e.target.select()}
                  onChange={(ev, value) => {
                    setSettlementScreeningFailureCoefficient(Number.parseFloat(value.value));
                    setIsChanged(true);
                  }}
                />
              </Field>
            )}
          </>
        )}
      </div>
      <div className='StageSelectorColumn StageSelectorColumnPrices'>
        {isSelected && props.ShowInputValues && <div className='StageSelectorColumnHeader'>Precios</div>}
        {props.applyToInFaceExecution && props.ShowInputValues && isSelected && (
          <Field label={t('protocolStageMultiSelector.stagesSelected.inPersonPrice')}>
            <Input
              id="inPersonPrice"
              type="number"
              style={{ maxWidth: '10em' }}
              contentAfter={
                <Text size={400} id={'inPersonPrice'}>
                  {props.CurrencyCode}
                </Text>
              }
              defaultValue={(props.CurrentConceptPaymentSchedule?.price || 0).toString()}
              onFocus={e => e.target.select()}
              onChange={(ev, value) => {
                setInPersonPrice(Number.parseFloat(value.value));
                setIsChanged(true);
              }}
            />
          </Field>
        )}
        {props.applyToRemoteExecution && props.ShowInputValues && isSelected && (
          <Field label={t('protocolStageMultiSelector.stagesSelected.remotePrice')}>
            <Input
              id="remotePrice"
              type="number"
              style={{ maxWidth: '10em' }}
              defaultValue={(props.CurrentConceptPaymentSchedule?.remotePrice || 0).toString()}
              contentAfter={
                <Text size={400} id={'remotePrice'}>
                  {props.CurrencyCode}
                </Text>
              }
              onFocus={e => e.target.select()}
              onChange={(ev, value) => {
                setRemotePrice(Number.parseFloat(value.value));
                setIsChanged(true);
              }}
            />
          </Field>
        )}
        {props.applyToPhoneExecution && props.ShowInputValues && isSelected && (
          <Field label={'Precio telefónico'}>
            <Input
              id="phonePrice"
              type="number"
              style={{ maxWidth: '10em' }}
              defaultValue={(props.CurrentConceptPaymentSchedule?.phonePrice || 0).toString()}
              contentAfter={
                <Text size={400} id={'phonePrice'}>
                  {props.CurrencyCode}
                </Text>
              }
              onFocus={e => e.target.select()}
              onChange={(ev, value) => {
                setPhonePrice(Number.parseFloat(value.value));
                setIsChanged(true);
              }}
            />
          </Field>
        )}
        { props.applyToFollowUpExecution && props.ShowInputValues && isSelected && (
          <Field label={'Precio seguimiento'}>
            <Input
              id="followUpPrice"
              type="number"
              style={{ maxWidth: '10em' }}
              defaultValue={(props.CurrentConceptPaymentSchedule?.followUpPrice || 0).toString()}
              contentAfter={
                <Text size={400} id={'followUpPrice'}>
                  {props.CurrencyCode}
                </Text>
              }
              onFocus={e => e.target.select()}
              onChange={(ev, value) => {
                setFollowUpPrice(Number.parseFloat(value.value));
                setIsChanged(true);
              }}
            />
          </Field>
        )}
        {props.applyToFailvisitExecution && props.Stage.failSelectionEnabled && isSelected && props.ShowInputValues && (
          <Field label={t('protocolStageMultiSelector.stagesSelected.selectionFailurePrice')}>
            <Input
              id="failurePrice"
              type="number"
              style={{ maxWidth: '10em' }}
              contentAfter={
                <Text size={400} id={'failurePrice'}>
                  {props.CurrencyCode}
                </Text>
              }
              defaultValue={(props.CurrentConceptPaymentSchedule?.screeningFailurePrice || 0).toString()}
              onFocus={e => e.target.select()}
              onChange={(ev, value) => {
                setFailurePrice(Number.parseFloat(value.value));
                setIsChanged(true);
              }}
            />
          </Field>
        )}
      </div>
    </div>
  );
};

export default connect(
  ComponentFuntions.mapStateToProps,
  ComponentFuntions.mapDispatchToProps
)(ContractStageMultiselectorItemComponent as any);